export const BACK_BUTTON_TEXT = "Back";
export const BACK_BUTTON_TEST_ID = "back-button";
